import { httpRequest } from '@calendly/http-tools'

const MAX_PAGE_SIZE = 100

export const getOrganizationMemberships = (query) => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params: {
    filter_term: query,
    sort_field: 'name',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const getOrganizationInvitations = (query) => httpRequest({
  url: '/api/organization/invitations',
  method: 'GET',
  params: {
    filter_term: query,
    status: 'pending',
    sort_field: 'email',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const getOrganizationMigrations = (query) => httpRequest({
  url: '/api/organization/migrations',
  method: 'GET',
  params: {
    filter_term: query,
    sort_field: 'email',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const requestSlugGeneration = ({ id = '', name }) => httpRequest({
  url: '/api/publishers/slug_generators/team',
  method: 'POST',
  data: {
    id,
    name
  }
})

export const createTeam = (data) => httpRequest({
  url: '/api/teams',
  method: 'POST',
  data
})

export const fetchTeam = ({ id }) => httpRequest({
  url: `/api/teams/${id}`,
  method: 'GET'
})

export const updateTeam = (id, data) => httpRequest({
  url: `/api/teams/${id}`,
  method: 'PATCH',
  data
})
